import { render, staticRenderFns } from "./formation-cycle-block.vue?vue&type=template&id=4b13c3da&"
import script from "./formation-cycle-block.vue?vue&type=script&lang=js&"
export * from "./formation-cycle-block.vue?vue&type=script&lang=js&"
import style0 from "./formation-cycle-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports